import { render, staticRenderFns } from "./EditAddressModal.vue?vue&type=template&id=5917509e&scoped=true&"
import script from "./EditAddressModal.vue?vue&type=script&lang=js&"
export * from "./EditAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5917509e",
  null
  
)

export default component.exports